import React from 'react'
import { Button } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import TextInput from '../../Input/TextInput/TextInput'
import { renderField } from '../../../utilities/reduxForm.util'
import { required } from '../../../utilities/validators'
import Loader from '../../Loader/Loader'

const VerifyPhoneForm = props => {
  const { error, registerLoading, submitting, handleSubmit, phone } = props

  return (
    <form onSubmit={handleSubmit} method="post" aria-labelledby="verify-phone-form-title">
      <div id="verify-phone-form-title" className="sr-only">
        Phone verification form
      </div>
      <div disabled={registerLoading}>
        <div className="sr-only">Phone number activation code verification</div>
        <div className="row">
          <div className="col-12 form-group">
            <TextInput
              name="phone"
              label="global.label.mobilePhone"
              value={phone}
              disabled
              aria-describedby="phone-readonly-note"
            />
            <div id="phone-readonly-note" className="sr-only">
              This field cannot be modified
            </div>
          </div>
        </div>
        <div className="row">
          <Field
            component={renderField}
            validate={[required]}
            inputType="input"
            type="text"
            containerclass="col-12 form-group"
            name="code"
            label="global.label.phoneActivationCode"
            aria-describedby="phone-activation-code-help"
          />
          <div id="phone-activation-code-help" className="sr-only">
            Enter the activation code sent to your phone number
          </div>
        </div>
        {error && (
          <div className="form-validation-error-message mb-2" role="alert" aria-live="polite">
            <FormattedMessage id={error} />
          </div>
        )}
        {submitting || registerLoading ? (
          <Loader aria-label="Verifying phone code" />
        ) : (
          <Button
            type="submit"
            outline
            color="dark"
            block
            aria-disabled={submitting || registerLoading}
            aria-describedby={error ? 'phone-verification-error' : undefined}
          >
            <FormattedMessage id="global.label.verifyPhone" />
          </Button>
        )}
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'VerifyPhoneForm',
})(VerifyPhoneForm)
